/**
 * Zgłoszenie + losowanie instant win — Figma 142:411, 160:5127 (animacja),
 * 160:5803 (wygrana), 160:5874 (przegrana).
 *
 * Backend rozstrzyga losowanie SYNCHRONICZNIE przy zapisie zgłoszenia
 * (CompletedApplicationProcessSubscriber → InstantWinPrizeManager), więc
 * odpowiedź `/api/application` zawiera już `prize`, `formUrl` oraz gotowy HTML
 * ekranu wygranej (`winHtml` — ApplicationWinHtmlSubscriber). Animacja jest
 * wyłącznie oprawą znanego wyniku — nic się tu nie losuje.
 *
 * Przebieg wg komentarza projektanta (Figma 2001:2955: „Animacja losowania
 * powinna trwać ok 2 sek. Pola powinny migać w różnych kolorach, a następnie
 * pokazać się wynik losowania"):
 *   1. formularz → ekran „Trwa losowanie…", z planszy znika zasłona,
 *   2. ok. 2 s migania kaflami w trzech kolorach marki,
 *   3. kafle wracają do koloru akcentu, a jeden odkrywa wynik: maskotki przy
 *      wygranej, X przy przegranej.
 *
 * Kafel z wynikiem jest losowy — Figma pokazuje go zawsze na 6. pozycji, ale to
 * tylko jedna klatka makiety, a stała pozycja przy kolejnych zgłoszeniach
 * wyglądałaby jak błąd.
 */

const FLICKER_COLORS = ['red', 'yellow', 'accent'];
const FLICKER_INTERVAL = 250;
const DRAW_DURATION = 2000;

$('.application-form').on('submit-success', function (event, data, xhr) {
	event.assert(201 == xhr.status && 'OK' == data.status);

	const $section = $(this).closest('.s-application');
	const won = Boolean(data.prize);

	// Ekran wygranej przychodzi gotowy z serwera (`winHtml`) — w HTML-u strony
	// go nie ma, żeby nie dało się zrobić fałszywego zrzutu ekranu zdjęciem
	// `d-none`. Wstawiamy go PRZED animacją, bo `runDraw` bierze z niego
	// grafikę nagrody dla kafla.
	if (won) {
		$section.find('[data-page="win"]').html(data.winHtml);
	}

	showPage($section, 'draw');
	scrollToSection($section);
	runDraw($section, won);

	if ('function' == typeof fbq) {
		fbq('track', 'CompleteRegistration');
	}
});

function showPage($section, name) {
	$section.find('[data-page]').addClass('d-none');
	$section.find(`[data-page="${name}"]`).removeClass('d-none');
}

/**
 * Sekcja jest wysoka, a zamiana ekranu zmienia jej wysokość — bez przewinięcia
 * użytkownik na mobile zostaje z animacją poza kadrem.
 */
function scrollToSection($section) {
	const navHeight = $('.c-nav-wrap').outerHeight(true) || 0;
	const top = Math.max($section.offset().top - navHeight, 0);

	window.scrollTo({ top: top, behavior: 'smooth' });
}

function runDraw($section, won) {
	const $draw = $section.find('[data-draw]');
	const $tiles = $draw.find('[data-draw-tile]');
	const prizeSrc = $section.find('.s-application__prize').attr('src');

	// Zasłona „Zagraj po rejestracji paragonu" znika na czas losowania.
	$draw.removeClass('c-draw--locked').addClass('c-draw--running');

	const flicker = setInterval(() => $tiles.each(function () {
		setTileColor($(this), randomColorOtherThan(currentColor($(this))));
	}), FLICKER_INTERVAL);

	setTimeout(() => {
		clearInterval(flicker);
		$tiles.each(function () {
			setTileColor($(this), null);
		});
		$draw.removeClass('c-draw--running');

		const $winning = $tiles.eq(Math.floor(Math.random() * $tiles.length));
		if (won) {
			$winning.addClass('c-draw__tile--prize').html(`<img class="c-draw__prize" src="${prizeSrc}" alt="">`);
		} else {
			$winning.addClass('c-draw__tile--loss').empty();
		}

		showPage($section, won ? 'win' : 'loss');
	}, DRAW_DURATION);
}

function currentColor($tile) {
	return FLICKER_COLORS.find(color => $tile.hasClass(`c-draw__tile--${color}`)) ?? null;
}

function randomColorOtherThan(color) {
	const pool = FLICKER_COLORS.filter(candidate => candidate !== color);

	return pool[Math.floor(Math.random() * pool.length)];
}

function setTileColor($tile, color) {
	FLICKER_COLORS.forEach(candidate => $tile.removeClass(`c-draw__tile--${candidate}`));
	if (color) {
		$tile.addClass(`c-draw__tile--${color}`);
	}
}
